import React from 'react';
import { Heading, Text, TextButton } from '@wix/design-system';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { PremiumEssentialsProvider, usePremiumEssentialsContext, } from '@wix/premium-fed-sdk/@premium-essentials';
import s from './BaseSuccessPage.module.scss';
import { useTranslation } from '../../../Infra';
import { ONE_DAY_IN_MILLISECONDS } from '../../../constants';
import { DomainsSharedComponentsModule } from '../../../Provider/DomainsSharedComponentsModule';
import cardImage from '../../../assets/success-page/connect-success-card-image.png';
import GoogleWorkspaceLogo from '../../../assets/success-page/connect-success-gws-logo.svg?url';
import { BaseSuccessPage } from './BaseSuccessPage';
import { EmailSaleSuccessPageHeaderContent } from './EmailSaleSuccessPageHeaderContent';
const REFERRAL_ADDITIONAL_INFO = 'domain_connect_success_be_upsell';
const MAILBOX_SALE_AMOUNT = 50;
const BUSINESS_EMAIL_SELECT_SEATS_URL = 'https://manage.wix.com/be-purchase/purchase/business-email/get-business-email/select-seats';
export const EmailSaleSuccessPage = ({ ...props }) => {
    const { i18n, Trans } = usePremiumEssentialsContext();
    return (React.createElement(PremiumEssentialsProvider, { i18n: i18n, Trans: Trans },
        React.createElement(DomainsSharedComponentsModule.Provider, { DomainsSharedTranslations: {
                Loading: React.createElement(React.Fragment, null),
            } },
            React.createElement(EmailSaleSuccessPageContent, { ...props }))));
};
const getBusinessEmailUrl = (siteDomain) => {
    const params = new URLSearchParams({
        domainName: siteDomain,
        referralAdditionalInfo: REFERRAL_ADDITIONAL_INFO,
    });
    return `${BUSINESS_EMAIL_SELECT_SEATS_URL}?${params.toString()}`;
};
const EmailSaleSuccessPageContent = ({ siteDomain, siteName = '', siteId, variant = 'connected', goLiveDate = new Date(Date.now() + 2 * ONE_DAY_IN_MILLISECONDS), }) => {
    const { t, Trans } = useTranslation();
    const accountParams = DomainsApiClient.hooks.useDomainsAccount({}).data;
    const hasSale = !!accountParams?.isMailboxOnSale;
    const email = DomainsApiClient.hooks.useUserDetails({}).data?.email ?? 'email';
    const viewSiteLink = `https://${siteDomain}`;
    const dashboardLinkUrl = `https://manage.wix.com/account/sites/${siteId ?? ''}`;
    const businessEmailUrl = getBusinessEmailUrl(siteDomain);
    return (React.createElement(BaseSuccessPage, { header: React.createElement(EmailSaleSuccessPageHeaderContent, { variant: variant, goLiveDate: goLiveDate, email: email, siteName: siteName, siteDomain: siteDomain, viewSiteLink: viewSiteLink }), card: {
            banner: hasSale
                ? {
                    body: t('my_domains_shared_components.success_page.business_email_sale.banner', { amount: MAILBOX_SALE_AMOUNT }),
                }
                : undefined,
            logo: {
                src: GoogleWorkspaceLogo,
                alt: 'Google Workspace',
            },
            title: hasSale ? (React.createElement(Heading, { className: s.cardTitle },
                React.createElement(Trans, { i18nKey: 'my_domains_shared_components.success_page.business_email_section.sale_title', components: [React.createElement("span", { style: { color: '#077842' } })] }))) : (React.createElement(Heading, { className: s.cardTitle },
                React.createElement(Trans, { i18nKey: 'my_domains_shared_components.success_page.business_email_section.nosale_title', values: {
                        domainName: siteDomain,
                    } }))),
            body: t('my_domains_shared_components.success_page.business_email_section.content', { domainName: siteDomain }),
            action: {
                as: 'a',
                href: businessEmailUrl,
                children: t('my_domains_shared_components.success_page.business_email_section.cta'),
            },
            image: { src: cardImage },
        }, footer: {
            body: (React.createElement(Text, { size: 'small' },
                React.createElement(Trans, { i18nKey: 'my_domains_shared_components.brand_protection.success_page.footer.go_to_dashboard', components: [
                        React.createElement(TextButton, { as: 'a', href: dashboardLinkUrl, skin: 'dark', underline: 'always', weight: 'bold', size: 'small' }),
                    ] }))),
        } }));
};
//# sourceMappingURL=EmailSaleSuccessPage.js.map